import {Box, Divider, Typography} from '@mui/material';
import HeaderWithIcons from '../app/HeaderWithIcons';
import {IPrayerCategory} from './PrayerCategory';
import {Link} from 'react-router-dom';
import EventBulletIcon from '@icons/EventBulletIcon';
import {useTranslation} from 'react-i18next';

interface IProps {
	prayer: IPrayerCategory,
	url: string,
}

export default function SubPrayer({prayer, url}: IProps) {
	const {t} = useTranslation();
	
	return (
		<div className="w-full h-full flex flex-col space-y-2">
			<HeaderWithIcons title={prayer.name}/>
			<Box sx={{borderColor: (theme) => theme.palette.mode === 'light' ? 'gray.100' : 'grey.700'}}
			     className="flex flex-col mx-4 border rounded">
				{
					prayer.children!.map((p, index) => <Link key={index} to={url + index}>
						<Box sx={{bgcolor: (theme) => theme.palette.mode === 'light' ? 'secondary.A200' : 'background.paper'}}
						     className="flex items-center px-4 h-12">
							<Typography sx={{
								color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.100',
								fontSize: (theme) => theme.typography.fontSize
							}} className="grow font-normal">{++index}) {p.name}</Typography>
							<EventBulletIcon flip={t('_dir') === 'ltr'}/>
						</Box>
						{
							index + 1 < prayer.children!.length && <Divider/>
						}
					</Link>)
				}
			</Box>
		</div>
	);
}
